// =====================================================================
// Sessão do estudante (portal UEB). Espelha o padrão do UEN, trocando o
// namespace pra '@UEB:'. Tudo em localStorage pra sobreviver a F5, nova
// aba e reabertura do navegador. Limpeza só em logout ou 401 do backend.
// =====================================================================
import Cookies from 'js-cookie';

export const UEB_TOKEN_KEY = '@UEB:token';
export const UEB_USER_KEY = '@UEB:user';
export const UEB_PIX_KEY = '@UEB:pixData';

// Chaves legadas que podem ter ficado no navegador de quem usou versões
// antigas. removeItem em chave inexistente é no-op — seguro listar todas.
const LEGACY_KEYS = ['user', 'token', 'auth', 'temCarteira', 'pixData', 'nome', 'cpf', 'id'];

export function setToken(token) {
    localStorage.setItem(UEB_TOKEN_KEY, token);
}

export function getToken() {
    return localStorage.getItem(UEB_TOKEN_KEY);
}

export function setUser(user) {
    localStorage.setItem(UEB_USER_KEY, JSON.stringify(user || null));
}

export function getUser() {
    try {
        const raw = localStorage.getItem(UEB_USER_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

// Atualiza campos pontuais do user salvo (ex.: email_verificado_at) sem
// perder o resto. Retorna o novo objeto (ou null se não havia user).
export function patchUser(patch) {
    const atual = getUser();
    if (!atual) return null;
    const novo = { ...atual, ...patch };
    setUser(novo);
    return novo;
}

export function isAuthenticated() {
    return !!getToken();
}

export function logout() {
    localStorage.removeItem(UEB_TOKEN_KEY);
    localStorage.removeItem(UEB_USER_KEY);
    localStorage.removeItem(UEB_PIX_KEY);
    LEGACY_KEYS.forEach((k) => {
        localStorage.removeItem(k);
        sessionStorage.removeItem(k);
    });
    Cookies.remove('login');
}

// ---- Pix persistido (retomar pagamento em aberto) ----
export function setPixData(data) {
    localStorage.setItem(UEB_PIX_KEY, JSON.stringify(data || null));
}

export function getPixData() {
    try {
        const raw = localStorage.getItem(UEB_PIX_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export function clearPixData() {
    localStorage.removeItem(UEB_PIX_KEY);
}
